export const BASE_URL = "https://api.goda-dent.com/api/admin/";
export const Bublic_URL = "https://api.goda-dent.com/";
